/**
 * safeSelectValue
 * ---------------------------------------------------------------------------
 * Helper pour eviter le crash Radix UI <Select> quand la valeur controlee
 * (ex: provenant d'une API) ne correspond a aucun <SelectItem> enfant.
 * Radix UI lance une exception "Script error" / TypeError dans ce cas.
 *
 * Usage type :
 *   import { safeSelectValue } from '../../lib/safeSelectValue';
 *
 *   setForm({
 *     mode: safeSelectValue(api.mode, ['virement','cheque','cb'], 'virement'),
 *     territoire: safeSelectValue(api.territoire, TERRITOIRE_IDS, ''),
 *   });
 *
 * Si l'allowedValues est vide ou la valeur invalide, retourne `fallback`.
 * Le fallback peut etre `''` si vous avez un placeholder, mais alors le Select
 * ne plantera pas grace au mode "uncontrolled" de Radix.
 */
export function safeSelectValue(rawValue, allowedValues, fallback = '') {
  if (rawValue === null || rawValue === undefined) return fallback;
  const str = String(rawValue);
  if (!Array.isArray(allowedValues) || allowedValues.length === 0) return fallback;
  // Recherche stricte
  if (allowedValues.includes(str)) return str;
  // Recherche case-insensitive (utile pour mode VIR -> virement)
  const lower = str.toLowerCase().trim();
  const found = allowedValues.find((v) => String(v).toLowerCase().trim() === lower);
  return found || fallback;
}

/**
 * Mappe une valeur brute (souvent une abreviation backend) vers une valeur
 * canonique attendue par les SelectItem du frontend.
 *
 * Ex: normalizeWithMap('VIR', { vir: 'virement', chq: 'cheque' }, 'virement')
 *     => 'virement'
 */
export function normalizeWithMap(rawValue, mapping, fallback = '') {
  if (rawValue === null || rawValue === undefined) return fallback;
  const lower = String(rawValue).toLowerCase().trim();
  return mapping[lower] || (Object.values(mapping).includes(lower) ? lower : fallback);
}

export default safeSelectValue;
